import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import { TimeStream, renderMoney } from '../../utils'
import { WKVisible } from '../../components/wk'
import * as relayAction from '../../actions/relays'


class ChannelRelayListItem extends React.Component {
    getRelayPercentFee (money, percent) {
        return money * percent / 100
    }
    onClickRelay (channel, e) {
        e.stopPropagation()
        this.props.relaySetCurrentChannel(channel)
        this.props.relayPostChannelCheck(channel.id)
    }
    onClickChannel (id) {
        window.location = `/channel/${id}`
    }
    render() {
        const channel = this.props.channel
        return (
            <div onClick={e => this.onClickRelay(channel, e)} className="box margin-bottom">
                <a href="javascript:;">
                    <div className="weui-flex border-line weui-padding">
                        <div className="weui-flex__item flex_3 background-image" style={{ backgroundImage: `url(${channel.cover_url})` }}>
                        </div>
                        <div className="weui-flex__item flex_9 padding-line overflow-hidden">
                            <p className="text-ellipsis big-font channel-title">{ channel.name }</p>
                            <WKVisible create={channel.money > 0}>
                                <p className="text-minor">学费:¥{renderMoney(channel.money)}（转载抽成
                                    <span className="key-num">
                                        ¥{renderMoney(this.getRelayPercentFee(channel.money, channel.relay_percent))}
                                    </span>）
                                </p>
                            </WKVisible>
                            <WKVisible create={channel.money === 0 || channel.money == null}>
                                <p className="text-minor">免费课</p>
                            </WKVisible>
                        </div>
                    </div>
                </a>
                {/* <div className="border-top-line text-right weui-padding" style={{ lineHeight: 1 }}>
                    <WKVisible create={channel.relay_fee > 0}>
                        <a href="javascript:;" onClick={e => this.onClickRelay(channel, e)} className="weui-btn weui-btn_mini weui-btn_primary">支付{renderMoney(channel.relay_fee)}转播</a>
                    </WKVisible>
                    <WKVisible create={channel.relay_fee === 0 || !channel.hasOwnProperty('relay_fee')}>
                        <a href="javascript:;" onClick={e => this.onClickRelay(channel, e)} className="weui-btn weui-btn_mini weui-btn_primary">点击免费转播</a>
                    </WKVisible>
                </div> */}
            </div>
        )
    }
}


export default connect(null, dispatch => bindActionCreators({ ...relayAction }, dispatch))(ChannelRelayListItem)



// WEBPACK FOOTER //
// ./src/components/relays/RelayChannelListItem.js